<template>
  <v-overlay :value="fancyModal">
    <v-card tile light width="300">
      <v-card-subtitle
        class="text-center pb-0 pt-2 font-weight-bold subtitle-1 text-capitalize"
      >
        {{ sessionName }}
      </v-card-subtitle>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">Runs</th>
                <th class="text-center">P&amp;L</th>
              </tr>
            </thead>
            <tbody v-if="!loading && runners">
              <tr v-for="(ladder, l) in runners" :key="`key-${l}`">
                <td class="text-center">
                  {{ ladder.start }}
                  {{
                    ladder.end &&
                    (ladder.end == 'Infinite' ? '+' : '-' + ladder.end)
                  }}
                </td>
                <td
                  class="text-center"
                  :class="{
                    'success--text': ladder.exposure >= 0,
                    'error--text': ladder.exposure < 0
                  }"
                >
                  <span v-if="ladder.exposure === 0">0</span>
                  <span v-if="ladder.exposure > 0 || ladder.exposure < 0">{{
                    (ladder.exposure / getMyRate()) | currencyFormat(0)
                  }}</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-skeleton-loader
          v-if="loading"
          tile
          light
          dense
          type="table-row-divider@1"
        >
        </v-skeleton-loader>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" small text @click="fancyModal = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      gameMode: 'SportsBook',
      valid: true
    }
  },
  computed: {
    ...mapState({
      sessionName: (state) => state.fancyLadders.sessionName,
      runners: (state) => state.fancyLadders.ladders,
      loading: (state) => state.fancyLadders.loading,
      sessionId: (state) => state.fancyLadders.sessionId
    }),
    fancyModal: {
      get() {
        return this.$store.getters['fancyLadders/modalOpen']
      },
      set(v) {
        return this.$store.commit('fancyLadders/set_modal', v)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.info-text {
  font-size: 10px;
  .info-icon {
    font-size: 13px;
  }
}
</style>
